<template>
  <el-popover
    v-if="isInit"
    v-model:visible="popoverVisible"
    :title="$t('main_menu_change')"
    placement="bottom"
    :popper-class="`menu-change-tips`"
    :width="300"
  >
    <div class="flex">
      <div>
        <div class="content">
          {{ $t('main_menu_change_tips') }}
        </div>
        <div class="menu-change-btn">
          <el-button @click="checkTips" type="text">{{ $t('main_menu_change_confirm') }}</el-button>
        </div>
      </div>
    </div>
    <template #reference>
      <el-button class="public-icon" type="text" size="medium" @click="handleExport">
        <i class="el-icon-document public-icon-i"></i>
      </el-button>
    </template>
  </el-popover>

  <el-tooltip
    v-else
    effect="dark"
    :content="$t('main_menu_export_menu_permission')"
    placement="bottom"
  >
    <el-button class="public-icon" type="text" size="medium" @click="handleExport">
      <i class="el-icon-document public-icon-i"></i>
    </el-button>
  </el-tooltip>
</template>

<script>
import { defineComponent, onMounted, ref, inject } from 'vue'
import { writeFile, utils } from 'xlsx'
import { MENU_LIST, NEW_MENU_FLAG } from './constants'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'ExportMenu',
  components: {},
  setup() {
    const store = useStore()

    const isInit = ref(!localStorage.getItem(NEW_MENU_FLAG))

    const popoverVisible = ref(false)

    const excelLink =
      'https://ztn.feishu.cn/wiki/P6fawjjQhiDQY9kcJA4cmXqRnPh?table=tblaDO5Uy6rg9oqy&view=vew8R7Jhfg'
    const handleExport = () => {
      // window.open(excelLink)
      const worksheet = utils.json_to_sheet(
        MENU_LIST.filter(item =>
          store.state.menu.pageList.some(el => el.routeUrl === item['菜单路由'])
        ).map((item, index) => {
          const obj = {
            ...item,
            序号: index + 1,
            菜单路由: undefined
          }
          delete obj.菜单路由
          return obj
        })
      )

      const workbook = utils.book_new()
      utils.book_append_sheet(workbook, worksheet, 'Sheet1')
      // 导出 Excel 文件
      writeFile(workbook, 'portal-menu.xlsx')
    }

    const checkTips = () => {
      localStorage.setItem(NEW_MENU_FLAG, 'true')
      popoverVisible.value = false
    }

    onMounted(() => {
      setTimeout(() => {
        popoverVisible.value = true
      }, 1 * 1000)
    })
    return {
      handleExport,
      isInit,
      popoverVisible,
      checkTips
    }
  }
})
</script>

<style scoped lang="scss"></style>

<style lang="scss">
.menu-change-tips {
  width: 300px;
  .menu-change-btn {
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
  }
}
</style>
